import { css } from '@emotion/react'
import Link from 'next/link'
import { colors, font, mq } from 'plume-ui'
import React from 'react'
import { useTimeout } from '../../hooks/useTimeout'
import { downloadDocumentUrl } from '@/lib/url'

type Props = {
  trackingIdPrefix: string
}

export const MobileGuestFloatingBanner: React.VFC<Props> = (props) => {
  const isAnimateTriggered = useTimeout(1500)

  return (
    <Link href={downloadDocumentUrl} passHref>
      <a
        data-testid="mobile-floating-banner"
        id={`${props.trackingIdPrefix}-mobile-floating-banner`}
        css={css`
          display: none;
          ${mq.untilMedium} {
            display: block;
            background: rgba(0, 0, 0, 0.85);
            height: 64px;
            width: calc(100% - 16px);
            border-radius: 16px;
            position: fixed;
            bottom: ${isAnimateTriggered ? '8px' : '-64px'};
            transition: bottom 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            left: 8px;
            color: ${colors.white00};
            z-index: 90;
          }
        `}
        target="_blank"
      >
        <div
          css={css`
            height: 100%;
            padding: 8px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          `}
        >
          <div
            css={css`
              flex-grow: 1;
            `}
          >
            <div
              css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                line-height: 1.5;
                letter-spacing: 0.02em;
              `}
            >
              <span
                css={css`
                  font-size: 12px;
                `}
              >
                \ スタートアップ情報 /
              </span>
              <span
                data-testid="text"
                css={css`
                  font-weight: ${font.weight.bold};
                  font-size: 20px;
                  // 横幅がかなり狭い場合の対応
                  ${mq.max(340)} {
                    font-size: 16px;
                  }
                `}
              >
                3分でわかるスピーダ
              </span>
            </div>
          </div>
          <div
            css={css`
              background: #0071e3;
              border-radius: 32px;
              padding: 10px 12px;
              white-space: nowrap;
              font-weight: ${font.weight.bold};
              font-size: 12px;
              line-height: 1;
            `}
          >
            ダウンロード
          </div>
        </div>
      </a>
    </Link>
  )
}
